import Meta from '../../components/common/Meta';
import RedesignPageLayout from '../../components/common/RedesignPageLayout';
import AdminRecommendPost from '../../components/admin/AdminRecommendPost';

const meta = {
    title: '推荐文章 - 管理页面 - 博客中心',
    keywords: '管理页面',
    description: '管理页面',
};

export default function AdminRecommendPostPage() {
    return (
        <>
            <Meta meta={meta} />
            <RedesignPageLayout>
                <header className="redesign-page-header">
                    <h1 className="redesign-page-title">推荐文章</h1>
                    <p className="redesign-page-desc">管理后台 — 添加新的推荐文章。</p>
                </header>
                <AdminRecommendPost />
            </RedesignPageLayout>
        </>
    );
}
